module.exports = __webpack_public_path__ + "img/SEFE.fe71ce60.png";